import { DDNAEvents } from './Tracker';
import { DeviceTypes } from './SessionParamBuilder';

export enum LevelTypes {
    ALL_TILES = 'all tiles',
    TOYS = 'toys',
    GOLDEN_TILES = 'golden tiles',
    TIMED = 'timed',
}

export interface IEventParams {
    eventName: DDNAEvents;
    timeSinceJSEnabled: number;
    frameRate: number;
}

export interface IMetaParams extends IEventParams {
    deviceType: DeviceTypes;
    gameID: string;
    gameVersion: string; // this is listed as a number (integer) but standard versioning (ie 2.1.0) does not convert to number
    operatingSystem: string;
    osVersion: number;
    platformUserID: string;
    sessionID: string;
    tzOffset: string;
    timezoneName: string;
    userID: string;
    locale: string;
    loadingTime: number;
    // all from session changing
    screenHeight: number;
    screenWidth: number;
    levelsPassedThisSession: number;
    levelsAttemptsThisSession: number;
    boostersUsedThisSession: number;
    adsWatchedThisSessionRewarded: number;
    adsWatchedThisSessionInterstitial: number;
    coinsEarnedThisSession: number;
    coinsSpentThisSession: number;
    // all from game state
    activeMap: string; // mapId converted to enum string
    activePieceSet: string;
    highestLevelNumber: number; // lastLevelIndex
    highestLevelID: string; // convert from lastLevelIndex
    stars: number;
    magnifyingGlassBooster: number;
    flashLightBooster: number;
    fireCrackerBooster: number;
    magnetBooster: number;
    coins: number;
    musicIsOn: number; // convert from boolean
    soundIsOn: number; // convert from boolean
    // all new saved properties
    consecutiveWinCount: number;
    consecutiveWinHighest: number;
    lastLevelAttempted: number;
    lastLevelWon: number;
    coinsSpent: number; // will start recording from when deltaDna version is live
    coinPurchasesMade: number;
    adsWatchedRewarded: number;
    adsWatchedInterstitial: number;
    livesBoughtWithCoins: number;
    numSocialShares: number;
    numSocialChallengesSent: number; // not implemented yet so will be 0
    adsLastTimeShownRewarded: number;
    adsLastTimeShown: number;
    numFriendsInvited: number;
}

/*
// currently not implemented params
interface IEntryPointAllParamsNotUsed {
    epSenderDaysInGame: number;
    epSenderIsPayer: number; // boolean - we don't have real money yet
}

// gate messages and beat high score are not part of the game right now
interface IEntryPointHighScoreParamsNotUsed {
    epLevelIndex: number;
}

interface IEntryGateMessageParamsNotUsed {
    epGateId: string;
    epForPlayer: any;
}

interface IMissionParamsAllNotUsed {
    mLevelMoves: number; // number of moves normally alotted...we don't have this
    mIsDailyChallenge: number; // we don't have yet
}

interface IMissionParamsEndNotUsed {
    mNumWheelSpins: number; // prize wheel is only on map not at end of level
    mAdsWatchedWheel: number; // ditto
    mScoreBeforeLevelEnd: number;
    mRetryNum: number; //hard to implement..will add later // TODO ...priority for next props
    mAdsWatchedDoubleReward: number //win screen where reward box appears would be after levelend is sent
}

interface IEntryPointBotParamsNotUsed {
    epUnlimitedLives: number; // not implemented in moji
}

interface IResourceParamsNotUsed {
    tGameArea: string; // I'm not understanding this game area stuff...thats ui and these events don't really connect with it
    // I may be able to find a way to include current game view when sending each event
    tDailyRewardNumber: number; // not implemented
}

interface IAdParamsNotUsed {
    adSdkVersion: string; //how do we get this?
    adWaterfallIndex: number; //how do we get this?
    adName: ''; //huh?...what is the ad placement JSON?
}

//just organizing and storing the tracking params I cannot implement right now
// and the reasons
interface IMetaParansNotUsedForNow {
    error: any; // I don't know what that refers too
    country: any; // I'm not sure I can get this info
    loadingTime: number; // don't know what this is refers to....just loading time?...and which loading? just to game start?
    consecutiveLoginDays: number; // need rules for global time (what's a day..our time or theirs),
    daysInGame: number; // same as above
    daysFromFirstLogin: number; // ditto
    realMoneySpent: number; // no real money yet
    zeroLivesRealMoneyPurchases: number; // "
    coinsBoughtWithRealMoney: number; // "
    highestLevel: number; // seems to be a duplicate of highestLevelNumber
    botMessageActive: boolean; // we can't tell in the game if they have opted in or not...we can only check if we can ask them again...this will be false if they are opted in or if they have refused within a certain time
    numFriendsPlayedWith: number; // holding off on all 'numFriends' for now...tougher to implement because we will need to store all friends counted and increment only with new friend
    numFriendsSentGiftTo: number;
    numFriendsRecievedGiftsFrom: number;
    numFriendsInteractedWith: number;
    numSessionsToday: number; // also all 'today' tracking needs to know when to start a day...user time or our time?...what to do about stored events not sent...(could be sent on future day)
    coinsEarnedToday: number;
    coinsSpentToday: number;
    adsWatchedTodayInterstitial: number;
    adsWatchedTodayRewarded: number;
    daysOffUntilToday: number; // same global time problems
    adsInteracted: any; // ?? how does this differ from ads watched...what does an 'interaction' consist of?
    postT: any; // need clarification on all of these postT params...this would not be a different value for the current number in inventory. It's how redux works, as soon as event is triggered all state updates to new values
    lossAversion: any; // we only have shuffle right now...Coins spent, rewarded ads watched maybe...but you could never watch an interstitial ad, no real money and coins spent and purchases would be the same?
    friendWhoInvitedToGame: number; // listed to take an integer but our userIds are strings ...'' if not invited? or 0 (convert userId's to nums?)
}
*/
